import React, { useState } from "react";
import { AlertTriangle, Check, X as XIcon, Info } from "lucide-react";
import { ILET_CARET_ALERT } from "../mock/mock";

const IletCaretAlert = () => {
  const [open, setOpen] = useState(true);
  if (!ILET_CARET_ALERT.active || !open) return null;

  return (
    <div className="relative bg-gradient-to-r from-[#FFC93C] via-[#FFD65A] to-[#FFC93C] border-y-2 border-[#0B2545]/10">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-2.5 md:py-4">
        <div className="flex items-start md:items-center gap-3 md:gap-4 flex-col md:flex-row pr-8 md:pr-0">
          <div className="flex items-center gap-3 shrink-0">
            <div className="h-9 w-9 md:h-11 md:w-11 rounded-full bg-[#0B2545] flex items-center justify-center shadow-md shrink-0">
              <AlertTriangle className="h-4 w-4 md:h-5 md:w-5 text-[#FFC93C]" />
            </div>
            <div>
              <div className="font-black text-[#0B2545] text-sm md:text-lg leading-tight tracking-tight">
                {ILET_CARET_ALERT.title}
              </div>
              <div className="text-[#0B2545]/80 text-[11px] md:text-sm font-semibold leading-snug">
                {ILET_CARET_ALERT.subtitle} — {ILET_CARET_ALERT.reason}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 md:gap-x-5 gap-y-1.5 md:gap-y-2 md:ml-4 flex-1">
            {ILET_CARET_ALERT.allowed.map((a, i) => (
              <div key={i} className="flex items-center gap-1.5 text-[#0B2545] text-[11px] md:text-sm font-bold">
                <span className="h-4 w-4 md:h-5 md:w-5 rounded-full bg-[#25D366] flex items-center justify-center shrink-0">
                  <Check className="h-3 w-3 md:h-3.5 md:w-3.5 text-white" strokeWidth={3} />
                </span>
                {a}
              </div>
            ))}
            {ILET_CARET_ALERT.forbidden.map((f, i) => (
              <div key={i} className="flex items-center gap-1.5 text-[#0B2545] text-[11px] md:text-sm font-bold">
                <span className="h-4 w-4 md:h-5 md:w-5 rounded-full bg-red-600 flex items-center justify-center shrink-0">
                  <XIcon className="h-3 w-3 md:h-3.5 md:w-3.5 text-white" strokeWidth={3} />
                </span>
                {f}
              </div>
            ))}
          </div>

          <button
            onClick={() => setOpen(false)}
            aria-label="Fermer"
            className="absolute top-2 right-2 md:static h-7 w-7 md:h-8 md:w-8 rounded-full bg-[#0B2545]/10 hover:bg-[#0B2545]/20 flex items-center justify-center transition"
          >
            <XIcon className="h-4 w-4 text-[#0B2545]" />
          </button>
        </div>
      </div>

      {/* Subtle info line */}
      <div className="bg-[#0B2545] text-white text-[10px] md:text-xs text-center py-1 md:py-1.5 tracking-wide md:tracking-widest font-semibold flex items-center justify-center gap-2 px-3">
        <Info className="h-3.5 w-3.5 text-[#FFC93C] shrink-0" />
        <span className="line-clamp-1">Nos excursions continuent — arrêt baignade & mouillage autour de l&apos;Îlet Caret</span>
      </div>
    </div>
  );
};

export default IletCaretAlert;
